import { getUsersByIds } from './GetUsersByIds';
import { getInternalUsers } from './GetInternalUsers';
import { getAllInternalUsers } from './GetAllInternalUsers';
import { getInternalUserMe } from './GetInternalUserMe';
import { getInternalUsersByRole } from './GetInternalUsersByRole';
import { getRecruiters } from './GetRecruiters';
import { getChildOffices } from './GetChildOffices';
import { getOffice } from './GetOffice';
import { getNpsReviews } from './GetNpsReviews';
import { searchOfficeUsers } from './SearchOfficeUsers';
import { getIdentityLocationCounts } from './GetIdentityLocationCounts';
import { getLocationUser } from './GetLocationUser';

/**
 * Users Service
 * Provides business logic layer for users operations
 */
export const UsersService = {
  getUsersByIds,
  getInternalUsers,
  getAllInternalUsers,
  getInternalUserMe,
  getInternalUsersByRole,
  getRecruiters,
  getChildOffices,
  getOffice,
  getNpsReviews,
  searchOfficeUsers,
  getIdentityLocationCounts,
  getLocationUser,
};
